import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  ReadonlyHttpApiCollectionRepository,
  Result,
} from '@softline/core';
import { FetteinheitenRechnerZeile } from '../data/fetteinheiten-rechner-zeile';
import { SOFTLINE_API_ROHSTOFFBEREITSTELLUNG_FETTEINHEITENRECHNER } from '../rohstoffbereitstellung.api';
import { RohstoffbereitstellungQuery } from '../services/query.service';

@Injectable()
export class FetteinheitenRechnerRepository extends ReadonlyHttpApiCollectionRepository<
  Result<FetteinheitenRechnerZeile[]>,
  any
> {
  constructor() {
    super(
      inject(ApiDataAccess),
      SOFTLINE_API_ROHSTOFFBEREITSTELLUNG_FETTEINHEITENRECHNER
    );
  }

  protected override getLoadPayload(
    params: RohstoffbereitstellungQuery
  ): unknown | undefined {
    return params;
  }
}
